import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import { valueStrings } from "constants/constantStrings";

const useStyles = makeStyles(() => ({
  requiredLabel: {
    fontSize: 9,
    fontWeight: "bold",
    color: "var(--color-medium-grey)",
    fontFamily: "Noto Sans"
  }
}));

const RenderMandatoryField = () => {
  const classes = useStyles();

  return <div className={classes.requiredLabel}>{valueStrings.mandatoryField}</div>;
};

export default RenderMandatoryField;
